<script setup>
import MainMenu from './MainMenu.vue';
</script>

<template>
    <div class="layout-sidebar shadow-sm rounded-2xl">
        <main-menu></main-menu>
    </div>
</template>

<style lang="scss" scoped></style>
